import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex align-center justify-center",
  style: {"height":"100vh"}
}

import { ref } from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import { auth0Module } from '@/store/entityModules/auth0';


export default /*@__PURE__*/_defineComponent({
  __name: 'SignIn',
  setup(__props) {

const isLoading = ref(true);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Loading), {
      active: isLoading.value,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((isLoading).value = $event)),
      "can-cancel": false,
      "is-full-page": false,
      loader: "bars",
      color: "#EE6090",
      width: 50,
      height: 50,
      "background-color": "transparent",
      opacity: 1
    }, null, 8, ["active"])
  ]))
}
}

})